import { addCardButtonStyles } from "@insite/content-library/Widgets/SavedPayments/SavedPaymentsAddCardButton";
import { cardListStyles } from "@insite/content-library/Widgets/SavedPayments/SavedPaymentsCardList";
import { defaultCardStyles } from "@insite/content-library/Widgets/SavedPayments/SavedPaymentsDefaultCard";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

cardListStyles.cardInfoContainer = {
    css: css`
        [class^="GridOffset"] {
            padding: 20px;
        }
    `,
};
defaultCardStyles.mainWrapper = {
    css: css`
        margin-top: 28px;
        background: ${getColor("common.background")};
        padding: 20px;
    `,
};
addCardButtonStyles.wrapper = {
    css: css`
        display: flex;
        justify-content: flex-end;
        button[data-test-selector^="popoverOverflowTrigger"] {
            background: none;
        }
    `,
};
